import locale from "../../../locale";

export const SCHEDULE_VIEWS = [
    {
        label: `${locale('pdfConstructor.lines')}`,
        value: 'lines',
    },
    {
        label: `${locale('pdfConstructor.tiles')}`,
        value: 'tiles',
    },
    {
        label: `${locale('pdfConstructor.grid')}`,
        value: 'grid',
    },
];

export const SCHEDULE_ORIENTATION = [
    {
        label: `${locale('pdfConstructor.horizontal')}`,
        value: 'landscape',
    },
    {
        label: `${locale('pdfConstructor.vertical')}`,
        value: 'portrait',
    },
];

export const FORMAT_A4 = 'a4';
export const FORMAT_FULLPAGE = 'fullpage';
export const FORMATS = [FORMAT_A4, FORMAT_FULLPAGE];
